<template>
  <div id="chart-donut">
    <apexchart
      :height="height || 350"
      :options="options"
      :series="series"
      type="donut"
      :width="width"/>
  </div>
</template>

<script>
//https://apexcharts.com/docs/options/plotoptions/pie/
export default {
  name: 'apexChartDonut',
  props: {
    height: [Number, String],
    width: [Number, String],
    chartOptions: {
      type: Object,
      required: true
    },
    series: {
      type: [Object, Array],
      required: true
    },
  },
  computed: {
    options() {
      let opt = this.chartOptions
      opt.chart.events ||= {}
      opt.chart.events.dataPointMouseEnter = (event, chartContext, config)  => {
        this.higlightLegend( event, chartContext, config )
      }
      opt.chart.events.dataPointMouseLeave = (event, chartContext, config)  => {
        this.higlightLegend( event, chartContext, config )
      }
      return opt
    }
  },
  methods: {
    higlightLegend( event, chartContext, config ) {
      let legends = chartContext.el.querySelectorAll('.apexcharts-legend-series')
      legends.forEach((element, n) => {
        if ( n != config.dataPointIndex ) {
          element.classList.toggle('hided')
        }
      })
    },
  }
}
</script>
<style lang="scss">
#chart-donut {
  width: 100%;
  .hided {
    opacity: 0.3;
  }
}
</style>
